// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { db } from '../firebase'; // Import Firestore
import { doc, getDoc, onSnapshot, query, collection } from 'firebase/firestore'; // Import Firestore methods

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [systemSettings, setSystemSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  // Real-time listener for user profile
  useEffect(() => {
    if (currentUser) {
      const userDocRef = doc(db, 'users', currentUser.uid);
      const unsubscribeUserProfile = onSnapshot(userDocRef, (doc) => {
        if (doc.exists()) {
          setUserProfile(doc.data());
        } else {
          setUserProfile(null);
        }
      });

      return () => unsubscribeUserProfile();
    } else {
      setUserProfile(null);
    }
  }, [currentUser]);

  useEffect(() => {
    const fetchSystemSettings = async () => {
      const q2 = query(collection(db, "SystemSettings")); 
      onSnapshot(q2, (querySnapshot2) => {
        querySnapshot2.forEach((doc) => {
          var tmp = doc.data();
          setSystemSettings(tmp);
        });
      });
    };
  
    fetchSystemSettings();
  }, []);

  /* useEffect(() => {
    const systemSettingsDocRef = doc(db, 'SystemSettings', 'setttings'); // Replace with actual doc ID if needed

    // Real-time listener for system settings
    const unsubscribeSystemSettings = onSnapshot(systemSettingsDocRef, (doc) => {
      if (doc.exists()) {
        setSystemSettings(doc.data());
      } else {
        setSystemSettings(null);
      }
    });

    return () => unsubscribeSystemSettings(); // Clean up the listener on unmount
  }, []); */


  

  const signup = (email, password) => {
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const login = (email, password) => {
    return signInWithEmailAndPassword(auth, email, password);
  };

  const logout = () => {
    console.log("signing out");
    return signOut(auth);
  };

  const value = {
    currentUser,
    userProfile, // Add userProfile to the context
    signup,
    login,
    logout,
    systemSettings,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};
